import angular from 'angular';

export const searchCacheService = ($localStorage, RouteService) => {
    const init = function () {
        $localStorage.searchCache = [];
        $localStorage.searchResults = {};
        $localStorage.lastSearchField = null;
        $localStorage.searchCache.push({
            name: null,
            fields: RouteService.getSystemPreference('searchCriteriaFields')
        });
        $localStorage.searchAvailableHistoryCount = RouteService.getSystemPreference('searchAvailableHistoryCount');
    };

    const checkInit = function () {
        if (!$localStorage.searchCache || !$localStorage.searchResults) {
            init();
        }
    };

    const getSearch = function (index) {
        checkInit();
        if ($localStorage.searchCache[index]) {
            return angular.copy($localStorage.searchCache[index]);
        }
        return angular.copy($localStorage.searchCache[0]);
    };

    const addSearch = function (searchData, currIndex) {
        checkInit();
        if ($localStorage.searchCache.length == $localStorage.searchAvailableHistoryCount) {
            $localStorage.searchCache.splice(1, 1);
        } else {
            $localStorage.searchCache.splice(currIndex + 1, $localStorage.searchCache.length - (currIndex + 1));
        }
        $localStorage.searchCache.push(searchData);
        return $localStorage.searchCache.length - 1;
    };

    const saveSearchResult = function (searchHistoryIndex, searchResults) {
        checkInit();
        $localStorage.searchResults = {
            searchHistoryIndex,
            searchResults,
        };
    };

    const clearSearchResults = function () {
        checkInit();
        if ($localStorage.searchResults) {
            $localStorage.searchResults.searchResults = null;
        }
    };

    const getSearchResults = function (searchHistoryIndex) {
        checkInit();
        if ($localStorage.searchResults && $localStorage.searchResults.searchHistoryIndex == searchHistoryIndex) {
            return $localStorage.searchResults.searchResults;
        }
        return null;
    };

    const saveLastSearchField = function (field, value, subCriteria) {
        checkInit();
        $localStorage.lastSearchField = {
            field,
            value,
            subCriteria,
        };
    };

    const getLastSearchField = function () {
        checkInit();
        const searchField = angular.copy($localStorage.lastSearchField);
        $localStorage.lastSearchField = null;
        return searchField;
    };

    return {
        init,
        getSearch,
        addSearch,
        clearSearchResults,
        saveSearchResult,
        getSearchResults,
        saveLastSearchField,
        getLastSearchField,
    };
};

angular
    .module('TALENYA-FE')
    .factory('searchCacheService', searchCacheService);
